import React from 'react'
import { useLocation } from 'react-router-dom'
import { Container, Alert, Card } from 'react-bootstrap'
import SystemReports from './index'
import { RemoteGetSystemReports } from '../../data/usecases/Reports/RemoteGetSystemReports'
import { URL_API } from '../../services/api_url'

const SystemReportsPage: React.FC = () => {
  const location = useLocation()
  const urlParams = new URLSearchParams(location.search)
  const secret = urlParams.get('secret')

  // Create the service
  const URL = URL_API || 'without-url'
  const remoteGetSystemReports = new RemoteGetSystemReports(`${URL}/reports`)

  if (!secret) {
    return (
      <Container
        fluid
        style={{
          padding: '40px 20px',
          background: '#f8f9fa',
          minHeight: '100vh'
        }}
      >
        <div style={{ maxWidth: '600px', margin: '0 auto', paddingTop: '10%' }}>
          <Card>
            <Card.Header className="bg-warning text-dark">
              <h4>
                <i className="feather icon-alert-triangle mr-2" />
                Acesso Restrito
              </h4>
            </Card.Header>
            <Card.Body>
              <Alert variant="warning">
                <h5>Parâmetro de acesso requerido</h5>
                <p>
                  Este relatório do sistema requer um parâmetro de acesso válido
                  na URL. Entre em contato com o administrador do sistema para
                  obter acesso.
                </p>
                <hr />
                <p className="mb-0">
                  <strong>Formato esperado:</strong>
                  <br />
                  <code>/system-reports?secret=CHAVE_DE_ACESSO</code>
                </p>
              </Alert>
            </Card.Body>
          </Card>
        </div>
      </Container>
    )
  }

  return (
    <SystemReports
      remoteGetSystemReports={remoteGetSystemReports}
      secret={secret}
    />
  )
}

export default SystemReportsPage
